'use client';

import { useState, useEffect } from 'react';
import Spinner from '../components/Spinner';
import ContactForm from '../components/ContactForm';
import { DefaultSeo } from 'next-seo';
import SEOHead from '../components/SEOHead';
import * as m from 'framer-motion/m';

const ContactPage = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <SEOHead
        title='Contact | GadgetFever'
        description='Get in touch with GadgetFever. We are here to help with your order, shipping questions, or anything else.'
        canonicalUrl='/contact'
        lang='en'
      />

      <div className='w-full min-h-screen bg-[#e8e8e8] dark:bg-black'>
        <m.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className='w-full pt-12 sm:pt-24 pb-20 px-4 flex justify-center'
        >
          {loading ? (
            <div className='flex justify-center items-center min-h-[50vh]'>
              <Spinner />
            </div>
          ) : (
            <div className='w-full max-w-5xl flex flex-col gap-10'>
              <ContactForm />
            </div>
          )}
        </m.div>
      </div>
    </>
  );
};

export default ContactPage;
